export enum EDIT_STORE_INFO_RESULT {
    "SUCCESSFUL" = "SUCCESSFUL",
    "FAILED" = "FAILED"
}